import Input from 'components/Form/Input'
import moment from 'moment'
import React from 'react'

import Label from 'components/Form/Label'
import CalendarIcon from 'components/icons/CalendarIcon'
import {
  DateStylePaper,
  FormItem,
  RadioGroup,
  StyledRadio,
  TwoFields,
} from 'modules/Students/Partials/AddNewStudentDrawer/Style/style'
import Select from 'components/Select'

const StudentDetails = ({
  studentType,
  onChangeStudentType,
  studentDOB,
  setStudentDOB,
  dateFormat = 'YYYY/MM/DD',
  gender,
  setGender,
  form,
}) => {
  const onDOBChange = (date, dateString) => {
    setStudentDOB(dateString)
  }
const genderOptions = [
  {
    value: 'MALE',
    name: 'MALE',
  },
  {
    value: 'FEMALE',
    name: 'FEMALE',
  },
  {
    value: 'TRANSGENDER',
    name: 'TRANSGENDER',
  },
  {
    value: 'INTERSEX',
    name: 'INTERSEX',
  },
  {
    value: 'NON_BINARY',
    name: 'NON_BINARY',
  },
  {
    value: 'PREFER_NOT_TO_SAY',
    name: 'PREFER_NOT_TO_SAY',
  },
  {
    value: 'OTHER',
    name: 'OTHER',
  },
]
  const validateName = label => (_, value) => {
    if (!value) {
      return Promise.reject(new Error(`Please enter ${label}!`))
    }

    if (!value.trim()) {
      return Promise.reject(new Error('Please Enter Valid Name!'))
    }
    if (/[\d]/.test(value)) {
      return Promise.reject(`${label} should not contain numbers`);
    }
    return Promise.resolve()
  }
  // Optional name validator: allows empty, but still blocks numbers when provided
  const validateOptionalName = label => (_, value) => {
    if (!value) {
      return Promise.resolve()
    }
    if (/[\d]/.test(value)) {
      return Promise.reject(`${label} should not contain numbers`);
    }
    return Promise.resolve()
  }
  const onGenderChange = (value) => {
    console.log(value, 'value')
    setGender(value)
    if (form && form.setFieldsValue) {
      form.setFieldsValue({
        gender: value,
      })
    }
  }

  return (
    <>
      <TwoFields spaceBetween>
        <Input
          width="47%"
          label="First Name"
          placeholder="Eg. Vikram"
          optional={'*'}
          name={'firstName'}
          rules={[
            {
              validator: validateName('first name'),
            },
          ]}
        />
        <Input
          width="47%"
          label="Last Name"
          placeholder="Eg. Sharma"
          name={'lastName'}
          rules={[
            {
              validator: validateOptionalName('last name'),
            },
          ]}
        />
      </TwoFields>

      <Input
        width="100%"
        label="Roll Number"
        placeholder="Eg. S123456780"
        name="uniRollNo"
        rules={[
          {
            required: false,
            message: 'Please enter roll number!',
          },
        ]}
      />
<FormItem name="gender" 
  rules={[
              {
                validator: async (_, value) => {
                  if (!gender) {
                    return Promise.reject(new Error('Please select a gender!'))
                  }
                  return Promise.resolve()
                },
              },
            ]}
>

      <Select
      valueParam={'name'}
      label="Gender *"
      placeholder="Eg. Male"
      OptionData={genderOptions}
      onChange={onGenderChange}
      filterOption={false}
      allowClear={true}
      value={gender}
    />
</FormItem>
      <div>
        <Label required={true}>D.O.B</Label>
        <FormItem
          name="dob"
          rules={[{ required: false, message: 'Please enter date of birth!' }]}
        >
          <DateStylePaper
            suffixIcon={<CalendarIcon />}
            id="date_of_birth"
            width="50%"
            color="#010E30"
            opacity="1"
            placeholder={dateFormat}
            format={dateFormat}
            onChange={onDOBChange}
            disabledDate={d => !d || d.isAfter(moment())}
          />
        </FormItem>
      </div>

      <div>
        <Label required={true}>
          Type <span>*</span>
        </Label>

        <FormItem
          name="type"
          rules={[
            {
              required: true,
              message: 'Please Choose any type!',
            },
          ]}
        >
          <RadioGroup value={studentType} onChange={onChangeStudentType}>
            <StyledRadio boxed={true} value={'regular'} label="Regular" />
            <StyledRadio
              boxed={true}
              value={'lateralEntry'}
              label="Lateral Entry"
            />
            <StyledRadio
              boxed={true}
              value={'transferred'}
              label="Transferred"
            />
          </RadioGroup>
        </FormItem>
      </div>
    </>
  )
}

export default StudentDetails
